module.exports = __webpack_public_path__ + "static/event-startup-weekend-6a14299e02e97e081a8b11546ebd499e.jpg";